import React from "react";
import { Container, Button } from "react-bootstrap";
import { FaHome, FaBroom, FaBrush } from "react-icons/fa";
import { Link } from "react-router-dom";
const PageNotFound = () => {
  return <section style={{
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f8fafc, #eef7f2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "50px 0"
  }}>
      <Container>
      
        <div style={{
        width: "140px",
        height: "140px",
        margin: "0 auto 30px",
        borderRadius: "50%",
        backgroundColor: "#2bb673",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 10px 25px rgba(43,182,115,0.25)"
      }}>
          <FaBroom size={60} color="#fff" />
        </div>

  
        <h1 style={{
        fontSize: "56px",
        fontWeight: "800",
        color: "#2bb673",
        marginBottom: "12px"
      }}>
          Cleaning in Progress 
        </h1>

        <h4 style={{
        fontWeight: "700",
        marginBottom: "15px",
        color: "#222"
      }}>
          404 - Page Not Found
        </h4>

       
        <p style={{
        color: "#666",
        fontSize: "17px",
        maxWidth: "650px",
        margin: "0 auto 35px",
        lineHeight: "1.9"
      }}>
          Looks like this page is being cleaned right now.
          Our team is making it spotless.
          Please head back to the homepage.
        </p>

     
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <Link to="/" style={{
          textDecoration: "none"
        }}>
            <Button style={{
            backgroundColor: "#2bb673",
            border: "none",
            padding: "12px 28px",
            fontWeight: "700",
            borderRadius: "30px"
          }}>
              <FaHome className="me-2" />
              Back to Home
            </Button>
          </Link>

          <Button style={{
          backgroundColor: "#fff",
          color: "#2bb673",
          border: "2px solid #2bb673",
          padding: "12px 28px",
          fontWeight: "700",
          borderRadius: "30px"
        }}>
            <FaBrush className="me-2" />
            Spotless Soon
          </Button>
        </div>
      </Container>
    </section>;
};
export default PageNotFound;
